var map = {
	"./coal.svg": "e8a9",
	"./copperIngot.svg": "2bc8",
	"./copperMine.svg": "85a5",
	"./food.svg": "f155",
	"./ironIngot.svg": "4071",
	"./ironMine.svg": "690a",
	"./population.svg": "5e91",
	"./science.svg": "9ccd",
	"./stone.svg": "362a",
	"./wood.svg": "5acc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0591";